// dependancies
import React from "reactn";
import appHook from "../../../hooks/appHook";
import Validate from "../userDetails/userDetailsRules";

//components
import EditableBlockWrapper from "./editable_form/EditableBlock";
import UserInfoForm from "../userDetails/user_info/userInfoForm";
import NewUserInfoForm from "../newUserDetails/user_info/userInfoForm";
import Address from "../userDetails/address/delivery_address/DeliveryAddress";
import NewAddress from "../newUserDetails/address/delivery_address/DeliveryAddress";
import Button from "../../_common/Button/Button";
import SelectedProducts from "./products/SelectedProducts";
import PaymentOptions from "../userDetails/payment_options/PaymentOptions";
import PaymentOption from "./payment_option/PaymentOption";
import ReviewProgress from "./progress/reviewProgress";

// styled components
import PageTitle from "../../_common/pageTitle/PageTitle.styled";
import PageText from "../../_common/pageText/PageText.styled";

//config
import { SubscriptionProducts } from "../subscriptions/product_list/Products.config";

import {
  Details,
  DeliveryAddressInternational,
  DeliveryAddressNational,
  NewDetails,
  NewAddressInternational,
  NewAddressNational
} from "./editable_form/EditableBlock.config";

const ReviewForm = () => {
  const {
    handleChange,
    handleKeyup,
    handleBlur,
    handleSubmit,
    values,
    errors
  } = appHook(Validate);

  const setFormActionValue = () => {
    if (window.collectorsCornerUser) {
      return "collectorsCornerUser";
    } else if (window.collectorsCornerSubs) {
      return "collectorsCornerSubs";
    } else if (window.collectorsCornerTopUp) {
      return "collectorsCornerTopUp";
    }
  };
  const antiForgeryTokenInput = document.querySelector("#tokenForm input");
  const antiForgeryTokenValue = antiForgeryTokenInput
    ? antiForgeryTokenInput.value
    : "";

  return (
    <div className="grid-container">
      <ReviewProgress></ReviewProgress>
      <PageTitle className="color--grey-d">Review</PageTitle>
      <div className="flex--space-between">
        <div className="m06__card__text">
          <form action="/RequestForm/CollectorsCorner/Submit" method="post">
            <EditableBlockWrapper
              title="Your details"
              errors={errors}
              config={Details}
              form={
                <UserInfoForm
                  handleChange={handleChange}
                  handleKeyup={handleKeyup}
                  handleBlur={handleBlur}
                  values={values}
                  errors={errors}
                />
              }
            ></EditableBlockWrapper>
            <EditableBlockWrapper
              title="Your Address"
              errors={errors}
              config={
                values.internationalSet
                  ? DeliveryAddressInternational
                  : DeliveryAddressNational
              }
              form={
                <Address
                  handleChange={handleChange}
                  handleKeyup={handleKeyup}
                  handleBlur={handleBlur}
                  values={values}
                  errors={errors}
                  formType={
                    values.internationalSet ? "international" : "national"
                  }
                ></Address>
              }
            ></EditableBlockWrapper>

            {window.collectorsCornerUser &&
              <>
                <EditableBlockWrapper
                  title="Your new details"
                  errors={errors}
                  config={NewDetails}
                  form={
                    <NewUserInfoForm
                      handleChange={handleChange}
                      handleKeyup={handleKeyup}
                      handleBlur={handleBlur}
                      values={values}
                      errors={errors}
                    />
                  }
                ></EditableBlockWrapper>
                <EditableBlockWrapper
                  title="Your new Address"
                  errors={errors}
                  config={
                    values.newinternationalSet
                      ? NewAddressInternational
                      : NewAddressNational
                  }
                  form={
                    <NewAddress
                      handleChange={handleChange}
                      handleKeyup={handleKeyup}
                      handleBlur={handleBlur}
                      values={values}
                      errors={errors}
                      formType={
                        values.newinternationalSet ? "international" : "national"
                      }
                    ></NewAddress>
                  }
                ></EditableBlockWrapper>
              </>
            }

            {(window.collectorsCorner || window.collectorsCornerSubs) &&
              <>
                <PageText>Products Selected</PageText>
                <SelectedProducts values={values} config={SubscriptionProducts}></SelectedProducts>
              </>
            }
            {(window.collectorsCorner || window.collectorsCornerTopUp) &&
              <PaymentOption title="Payment Option" form={<PaymentOptions errors={errors} values={values}></PaymentOptions>}></PaymentOption>
            }
            <input type="hidden" name="formAction" value={setFormActionValue()} />
            <input type="hidden" name="__RequestVerificationToken" value={antiForgeryTokenValue} />
            <Button
              className="bn bn--primary gtm-linkclick"
              type="submit"
              text="Submit"
              onClick={() => {
                handleSubmit();
              }}
            />
          </form>
        </div>
      </div>
    </div >
  );
};

export default ReviewForm;
